import { render, staticRenderFns } from "./ImgPlaceholder.vue?vue&type=template&id=ee5ada38&scoped=true"
import script from "./ImgPlaceholder.vue?vue&type=script&lang=js"
export * from "./ImgPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5ada38",
  null
  
)

export default component.exports